<app-loading-spinner *ngIf="showLoadingSpinner; else mainSection">
</app-loading-spinner>

<ng-template #mainSection
  ><app-banner
    [image]="image"
    [bannerTitle]="bannerTitle"
    [additionalStyles]="{ height: '21vh' }"
    [bannerTextStyles]="{ left: '7vw', top:'7vw' }"
  ></app-banner>

  <section class="bookmark-section">
    <div class="row col-md-12 back-icon-row" (click)="onBackClick()">
      <span class="back-icon-container" style="cursor: pointer;">
      <span class="uil-dl-icon-Arrow-left uil-color-primary back-icon"></span>
      <span class="back-icon-text">Back</span>
    </span>
    </div>

    <div class="row" style="align-items: center">
      <div class="col-md-3">
        <div class="search-bar marginLeft">
          <span class="search-icon"><i class="fa fa-search"></i></span
          ><input
            type="text"
            placeholder="Search"
            class="form-control search-input"
            [(ngModel)]="searchText"
          />
        </div>
      </div>

      <div class="col-md-3">
        <span
          class="search-result"
          *ngIf="
            (assetList | filter: searchText)?.length > 0
          "
          style="font-weight: 500"
          >Showing {{ (assetList | filter: searchText).length }} of
          {{ assetList.length }}
        </span>
      </div>
    </div>

    <div class="row bookmarked-asset-row" *ngIf="assetList.length" [ngStyle]="{'margin-top': (assetList | filter: searchText).length ? '24px' : '0px'}">
      <div
        class="col-md-4"
        *ngFor="let data of assetList | filter: searchText"
        style="padding-right: 0px"
      >
        <app-asset-card
          [card]="data"
          [searchText]="searchText"
          (bookmarkEvent)="onBoookmarkClick($event)"
        ></app-asset-card>
      </div>
    </div>

    <div class="no-bookmark" *ngIf="assetList.length == 0; else noresultfound ">You have not created any bookmarks yet. Use the bookmark on the asset cards to save here.</div>

    <ng-template #noresultfound>
      <h4 *ngIf="(assetList | filter: searchText)?.length== 0" style="padding-left:18px"> No result found </h4>
    </ng-template>
  </section>
</ng-template>
